import _get from 'lodash/get';

import ReportIncidentsStartModel from '$models/ReportIncidentsStartModel';

import MMCollection from './MMCollection';


const filterDictionary = {
	post_code: 'field_incident_post_code',
	category: 'field_incident_category.id',
	volume: 'field_incident_volume',
	status: 'field_incident_status',
	team: 'field_incident_team',
	bin_hasremarks: 'field_incident_bin_hasremarks',
};

export default class ReportIncidentsStartCollection extends MMCollection {
	constructor(args = {}) {
		args = Object.assign({}, args);
		args.Model = args.Model || ReportIncidentsStartModel;
		args.filterDictionary = filterDictionary;
		args.useProQueryParams = true;
		super(args);
	}

	parse(response) {
		return super.parse([new this.Model().set(response)]);
	}


	fetchSuper() {
		// super.fetch can be only called in method.
		return super.fetch();
	}

	async fetch() {
		const maxAttempts = 60;
		let response;

		// `loading` flips back to false after every request, so keep a flag up
		// for the whole polling cycle ("We are building your response" retries).
		this.reportFetchPending = true;
		try {
			for (let attempt = 0; attempt < maxAttempts; attempt++) {
				response = await this.fetchSuper();
				if (!this.isBuilding(response)) return response;
				await new Promise((resolve) => setTimeout(resolve, 500));
			}

			return response;
		} finally {
			this.reportFetchPending = false;
		}
	}

	//OLD FETCH - It Did refetch - but only first result was returned
	// fetch() {
	// 	const communityID = localStorage.getItem('communityID') || window.vueStore.state.session.user.community.id;
	// 	this.setConfig('url', `${Config.getUrl('reportIncidentsStart')}/${communityID}`);

	// 	return super.fetch().then((response) => {
	// 		if (this.isBuilding) {
	// 			_delay(() => this.fetch(), 3000);
	// 		}
	// 		if(!this.isBuilding) return response;
	// 	});
	// }

	// get isBuilding() {
	// 	return !_has(this.models, '[0].data') || _isString(_get(this.models, '[0].data'));
	// }

	isBuilding(xhr) {
		const payload = xhr && xhr.originalData !== undefined ? xhr.originalData : xhr && xhr.data;
		return isBuildingPayload(payload) || isBuildingPayload(_get(xhr, 'data[0].data'));
	}
}

function isBuildingPayload(payload) {
	if (typeof payload === 'string') {
		const trimmed = payload.trim();
		if (!trimmed || trimmed.startsWith('{') || trimmed.startsWith('[')) return false;
		return true;
	}

	if (payload && typeof payload === 'object' && typeof payload.data === 'string') {
		return isBuildingPayload(payload.data);
	}

	return false;
}
